type OrganizationDeactivatedHandler = () => void;

let currentHandler: OrganizationDeactivatedHandler | null = null;

export function setOrganizationDeactivatedHandler(handler: OrganizationDeactivatedHandler | null): void {
  currentHandler = handler;
}

export function notifyOrganizationDeactivated(): void {
  if (currentHandler) {
    currentHandler();
  }
}
